module.exports = __webpack_public_path__ + "img/aplicacao_pelicula2.4b79453e.jpeg";